import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=363f4d56&scoped=true"
import script from "./doctorInfo.vue?vue&type=script&lang=js"
export * from "./doctorInfo.vue?vue&type=script&lang=js"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=363f4d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4d56",
  null
  
)

export default component.exports